import React, { FC } from 'react';
import { MainLoader } from 'ia-react-core';
import { StyledExperienceCover } from './ExperienceCover.styles';

interface ExperienceCoverProps {
  experienceDetected: boolean;
}

const ExperienceCover: FC<ExperienceCoverProps> = ({ experienceDetected }) =>
  <>{!experienceDetected && <StyledExperienceCover data-testid="experience-cover"><div className="ia-app-loader"><MainLoader /></div></StyledExperienceCover>}</>;

export default ExperienceCover;
